import React, {FC} from 'react'
import {useSelector} from 'react-redux'
import {useAppDispatch} from 'redux/config'
import {FilterSelect} from '@mdsol/onex-design'
import {handleGridChange} from '../../../../redux/jobRequests/jobRequests.duck'
import './filtersPanel.scss'
import {select_jobRequestOptions, select_filtersVM} from 'redux/jobRequests/selectors'
import {getFilterOptions} from 'redux/jobRequests/helpers'
const FiltersPanel: FC = () => {
  const dispatch = useAppDispatch()
  const {category} = useSelector(select_filtersVM)
  const jobRequestOptions = useSelector(select_jobRequestOptions)
  const options = getFilterOptions(jobRequestOptions)

  const getHandlerForFilter = (filterName: 'scope' | 'category') => (option) => {
    dispatch(handleGridChange({filters: {name: filterName, option: option[0]}}))
  }

  return (
    <div id='event-messaging-filters-panel' className='onex-data-grid-filters'>
      <div className='onex-data-grid-filters-container'>
        <FilterSelect
          dataTestId='category-filter'
          label='Job Request Category'
          value={[category]}
          options={options}
          onChange={getHandlerForFilter('category')}
        />
      </div>
    </div>
  )
}

export default FiltersPanel
